import {
  AcademicCapIcon,
  HomeIcon,
  TruckIcon,
  BeakerIcon,
  ExclamationCircleIcon,
  HeartIcon,
  GlobeAltIcon,
  BanknotesIcon,
  StarIcon,
} from '@heroicons/react/24/outline';

// Map icon names to icon components
export const iconMap = {
  AcademicCapIcon,
  HomeIcon,
  TruckIcon,
  BeakerIcon,
  ExclamationCircleIcon,
  HeartIcon,
  GlobeAltIcon,
  BanknotesIcon,
  StarIcon,
};

/**
 * Get icon component from icon name
 * @param {string} iconName - Name of the icon (e.g., 'AcademicCapIcon')
 * @returns {React.Component} Icon component or default StarIcon
 */
export const getGoalIcon = (iconName) => {
  // If icon exists, return it
  if (iconName && iconMap[iconName]) {
    return iconMap[iconName];
  }

  // Default fallback to StarIcon
  return StarIcon;
};
